import React, { memo } from 'react'
import { Box, Grid } from '@material-ui/core'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import PageMetaData from '@v4/utils/data/PageMetaData'
import EditableHTML from '@v4/components/common/EditableHTML'
import ActionButton from '@v4/components/common/Buttons/ActionButton'
import Image from '@v4/components/common/Image'
import SortHandler from '@v4/components/common/SortHandler'
import EditableContainer from '@v4/components/common/EditableContainer'
import { useBanner23 } from './Banner23.hooks'

const Banner23 = props => {
	const [
		{
			image,
			classes,
			withBgImage,
			isMobile,
			withMobileImage,
			direction,
			textShadow,
			contentWidth,

			text,
			textConfig,
			textKey,
			textEditable,

			buttonText,
			buttonAction,
			buttonLink,
			buttonTextEditable,
			buttonTextConfig,
			buttonTextKey,
		},
		{
			handleImageClick,

			handleTextClick,
			handleTextChange,

			handleButtonClick,
			handleButtonTextChange,
		},
	] = useBanner23(props)

	return (
		<div className={clsx(classes.root, 'banner23')}>
			{withBgImage && (
				<Image className={clsx(classes.bgImage, 'banner23-bg-image')} metaData={image} isBackground />
			)}
			<Grid className={clsx(classes.grid, 'banner23-grid')} container justify="center" alignItems="center">
				<SortHandler key={isMobile ? 'mobile' : 'desktop'} direction={direction}>
					<Grid
						className={clsx(classes.contentWrap, 'banner23-content-wrap')}
						lg={contentWidth}
						md={contentWidth}
						sm={10}
						xs={12}
						item
					>
						<div className={clsx(classes.content, 'banner23-content')}>
							<EditableContainer
								visible={!!text}
								fieldConfig={textConfig}
								onAdd={handleTextChange}
								editable={textEditable}
								white={withBgImage}
							>
								<EditableHTML
									key={textKey}
									className={clsx(classes.text, 'banner23-text-block')}
									white={withBgImage}
									gutterBottom
									html={text}
									onClick={handleTextClick}
									editable={textEditable}
									onChange={handleTextChange}
									isWhite={withBgImage}
									textShadow={textShadow}
								/>
							</EditableContainer>
							<EditableContainer
								visible={!!buttonText}
								fieldConfig={buttonTextConfig}
								onAdd={handleButtonTextChange}
								editable={buttonTextEditable}
								white={withBgImage}
								label="Button"
								wrapper={({ children }) => (
									<Box className={clsx(classes.buttonWrap, 'banner23-button-wrapper')}>
										{children}
									</Box>
								)}
							>
								<ActionButton
									key={buttonTextKey}
									editable={buttonTextEditable}
									action={buttonAction}
									href={buttonLink}
									className={clsx(classes.buttonRoot, 'banner23-button')}
									onClick={handleButtonClick}
									onChange={handleButtonTextChange}
								>
									{buttonText}
								</ActionButton>
							</EditableContainer>
						</div>
					</Grid>
					{withMobileImage && (
						<Grid className={clsx(classes.imageGrid, 'banner23-image-grid')} xs={12} item>
							<Box className={classes.mobileImageWrapper}>
								<Image
									className={clsx(classes.mobileImage, 'banner23-image-mobile')}
									metaData={image}
									onClick={handleImageClick}
								/>
							</Box>
						</Grid>
					)}
				</SortHandler>
			</Grid>
		</div>
	)
}

Banner23.propTypes = {
	metaData: PropTypes.shape({
		text: PropTypes.instanceOf(PageMetaData),
		backgroundImage: PropTypes.instanceOf(PageMetaData),
		buttonText: PropTypes.instanceOf(PageMetaData),
		buttonLink: PropTypes.instanceOf(PageMetaData),
		buttonAction: PropTypes.instanceOf(PageMetaData),
		mobileAlignment: PropTypes.instanceOf(PageMetaData),
		mobileImagePosition: PropTypes.instanceOf(PageMetaData),
		mobileImage: PropTypes.instanceOf(PageMetaData),
		backgroundImagePosition: PropTypes.instanceOf(PageMetaData),
		contentWidth: PropTypes.instanceOf(PageMetaData),
	}).isRequired,
}

export default memo(Banner23)
